import classNames from 'classnames';
import Link from 'next/link';

import { Logo } from '@/components/Logo';

export function HoverableLogo() {
  const sharedLogoColorClassNames =
    'absolute inset-0 transition-all mix-blend-multiply';

  return (
    <Link
      href="/"
      className={classNames(
        'block text-paper dark:text-gray-800 p-3 w-full h-12',
        'relative group',
      )}
    >
      <Logo className="fill-current block w-auto h-6 relative z-1" />

      {/* Effects Layer 4 */}
      <div className="absolute inset-0 z-0">
        <span
          className={classNames(
            sharedLogoColorClassNames,
            'bg-cyan-400 group-hover:translate-x-half group-hover:translate-y-1 group-hover:rotate-1',
          )}
        />
        <span
          className={classNames(
            sharedLogoColorClassNames,
            'bg-magenta-400 group-hover:-translate-x-1 group-hover:translate-y-half group-hover:-rotate-1',
          )}
        />

        <span
          className={classNames(
            sharedLogoColorClassNames,
            'bg-yellow-400 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:rotate-2',
          )}
        />
        <span className="absolute bg-black dark:bg-gray-200 inset-0" />
      </div>
    </Link>
  );
}
